module.exports = __webpack_public_path__ + "img/hero-slide-1.0556c878.svg";